export interface GeoListItemType {
  name: string
  code: string
}

interface GeoCountryEntry {
  nameEn: string
  nameCs: string
  code: string
}

const countryList: GeoCountryEntry[] = [
  { nameEn: 'Czech Republic', nameCs: 'Česká republika', code: 'CZ' },
  { nameEn: 'Slovakia', nameCs: 'Slovensko', code: 'SK' },
  { nameEn: 'Afghanistan', nameCs: 'Afghánistán', code: 'AF' },
  { nameEn: 'Åland Islands', nameCs: 'Alandy', code: 'AX' },
  { nameEn: 'Albania', nameCs: 'Albánie', code: 'AL' },
  { nameEn: 'Algeria', nameCs: 'Alžírsko', code: 'DZ' },
  { nameEn: 'American Samoa', nameCs: 'Americká Samoa', code: 'AS' },
  { nameEn: 'Andorra', nameCs: 'Andorra', code: 'AD' },
  { nameEn: 'Angola', nameCs: 'Angola', code: 'AO' },
  { nameEn: 'Anguilla', nameCs: 'Anguilla', code: 'AI' },
  { nameEn: 'Antarctica', nameCs: 'Antarktida', code: 'AQ' },
  { nameEn: 'Antigua and Barbuda', nameCs: 'Antigua a Barbuda', code: 'AG' },
  { nameEn: 'Argentina', nameCs: 'Argentina', code: 'AR' },
  { nameEn: 'Armenia', nameCs: 'Arménie', code: 'AM' },
  { nameEn: 'Aruba', nameCs: 'Aruba', code: 'AW' },
  { nameEn: 'Australia', nameCs: 'Austrálie', code: 'AU' },
  { nameEn: 'Austria', nameCs: 'Rakousko', code: 'AT' },
  { nameEn: 'Azerbaijan', nameCs: 'Ázerbájdžán', code: 'AZ' },
  { nameEn: 'Bahamas', nameCs: 'Bahamy', code: 'BS' },
  { nameEn: 'Bahrain', nameCs: 'Bahrajn', code: 'BH' },
  { nameEn: 'Bangladesh', nameCs: 'Bangladéš', code: 'BD' },
  { nameEn: 'Barbados', nameCs: 'Barbados', code: 'BB' },
  { nameEn: 'Belarus', nameCs: 'Bělorusko', code: 'BY' },
  { nameEn: 'Belgium', nameCs: 'Belgie', code: 'BE' },
  { nameEn: 'Belize', nameCs: 'Belize', code: 'BZ' },
  { nameEn: 'Benin', nameCs: 'Benin', code: 'BJ' },
  { nameEn: 'Bermuda', nameCs: 'Bermudy', code: 'BM' },
  { nameEn: 'Bhutan', nameCs: 'Bhútán', code: 'BT' },
  { nameEn: 'Bolivia', nameCs: 'Bolívie', code: 'BO' },
  { nameEn: 'Bosnia and Herzegovina', nameCs: 'Bosna a Hercegovina', code: 'BA' },
  { nameEn: 'Botswana', nameCs: 'Botswana', code: 'BW' },
  { nameEn: 'Bouvet Island', nameCs: 'Bouvetův ostrov', code: 'BV' },
  { nameEn: 'Brazil', nameCs: 'Brazílie', code: 'BR' },
  { nameEn: 'British Indian Ocean Territory', nameCs: 'Britské indickooceánské území', code: 'IO' },
  { nameEn: 'Brunei Darussalam', nameCs: 'Brunej', code: 'BN' },
  { nameEn: 'Bulgaria', nameCs: 'Bulharsko', code: 'BG' },
  { nameEn: 'Burkina Faso', nameCs: 'Burkina Faso', code: 'BF' },
  { nameEn: 'Burundi', nameCs: 'Burundi', code: 'BI' },
  { nameEn: 'Cambodia', nameCs: 'Kambodža', code: 'KH' },
  { nameEn: 'Cameroon', nameCs: 'Kamerun', code: 'CM' },
  { nameEn: 'Canada', nameCs: 'Kanada', code: 'CA' },
  { nameEn: 'Cape Verde', nameCs: 'Kapverdy', code: 'CV' },
  { nameEn: 'Cayman Islands', nameCs: 'Kajmanské ostrovy', code: 'KY' },
  { nameEn: 'Central African Republic', nameCs: 'Středoafrická republika', code: 'CF' },
  { nameEn: 'Chad', nameCs: 'Čad', code: 'TD' },
  { nameEn: 'Chile', nameCs: 'Chile', code: 'CL' },
  { nameEn: 'China', nameCs: 'Čína', code: 'CN' },
  { nameEn: 'Christmas Island', nameCs: 'Vánoční ostrov', code: 'CX' },
  { nameEn: 'Cocos (Keeling) Islands', nameCs: 'Kokosové ostrovy', code: 'CC' },
  { nameEn: 'Colombia', nameCs: 'Kolumbie', code: 'CO' },
  { nameEn: 'Comoros', nameCs: 'Komory', code: 'KM' },
  { nameEn: 'Congo', nameCs: 'Kongo', code: 'CG' },
  { nameEn: 'The Democratic Republic of the Congo', nameCs: 'Konžská demokratická republika', code: 'CD' },
  { nameEn: 'Cook Islands', nameCs: 'Cookovy ostrovy', code: 'CK' },
  { nameEn: 'Costa Rica', nameCs: 'Kostarika', code: 'CR' },
  { nameEn: "Cote D'Ivoire", nameCs: 'Pobřeží slonoviny', code: 'CI' },
  { nameEn: 'Croatia', nameCs: 'Chorvatsko', code: 'HR' },
  { nameEn: 'Cuba', nameCs: 'Kuba', code: 'CU' },
  { nameEn: 'Cyprus', nameCs: 'Kypr', code: 'CY' },
  { nameEn: 'Denmark', nameCs: 'Dánsko', code: 'DK' },
  { nameEn: 'Djibouti', nameCs: 'Džibutsko', code: 'DJ' },
  { nameEn: 'Dominica', nameCs: 'Dominika', code: 'DM' },
  { nameEn: 'Dominican Republic', nameCs: 'Dominikánská republika', code: 'DO' },
  { nameEn: 'Ecuador', nameCs: 'Ekvádor', code: 'EC' },
  { nameEn: 'Egypt', nameCs: 'Egypt', code: 'EG' },
  { nameEn: 'El Salvador', nameCs: 'Salvador', code: 'SV' },
  { nameEn: 'Equatorial Guinea', nameCs: 'Rovníková Guinea', code: 'GQ' },
  { nameEn: 'Eritrea', nameCs: 'Eritrea', code: 'ER' },
  { nameEn: 'Estonia', nameCs: 'Estonsko', code: 'EE' },
  { nameEn: 'Ethiopia', nameCs: 'Etiopie', code: 'ET' },
  { nameEn: 'Falkland Islands (Malvinas)', nameCs: 'Falklandy', code: 'FK' },
  { nameEn: 'Faroe Islands', nameCs: 'Faerské ostrovy', code: 'FO' },
  { nameEn: 'Fiji', nameCs: 'Fidži', code: 'FJ' },
  { nameEn: 'Finland', nameCs: 'Finsko', code: 'FI' },
  { nameEn: 'France', nameCs: 'Francie', code: 'FR' },
  { nameEn: 'French Guiana', nameCs: 'Francouzská Guyana', code: 'GF' },
  { nameEn: 'French Polynesia', nameCs: 'Francouzská Polynésie', code: 'PF' },
  { nameEn: 'French Southern Territories', nameCs: 'Francouzská jižní a antarktická území', code: 'TF' },
  { nameEn: 'Gabon', nameCs: 'Gabon', code: 'GA' },
  { nameEn: 'Gambia', nameCs: 'Gambie', code: 'GM' },
  { nameEn: 'Georgia', nameCs: 'Gruzie', code: 'GE' },
  { nameEn: 'Germany', nameCs: 'Německo', code: 'DE' },
  { nameEn: 'Ghana', nameCs: 'Ghana', code: 'GH' },
  { nameEn: 'Gibraltar', nameCs: 'Gibraltar', code: 'GI' },
  { nameEn: 'Greece', nameCs: 'Řecko', code: 'GR' },
  { nameEn: 'Greenland', nameCs: 'Grónsko', code: 'GL' },
  { nameEn: 'Grenada', nameCs: 'Grenada', code: 'GD' },
  { nameEn: 'Guadeloupe', nameCs: 'Guadeloupe', code: 'GP' },
  { nameEn: 'Guam', nameCs: 'Guam', code: 'GU' },
  { nameEn: 'Guatemala', nameCs: 'Guatemala', code: 'GT' },
  { nameEn: 'Guernsey', nameCs: 'Guernsey', code: 'GG' },
  { nameEn: 'Guinea', nameCs: 'Guinea', code: 'GN' },
  { nameEn: 'Guinea-Bissau', nameCs: 'Guinea-Bissau', code: 'GW' },
  { nameEn: 'Guyana', nameCs: 'Guyana', code: 'GY' },
  { nameEn: 'Haiti', nameCs: 'Haiti', code: 'HT' },
  { nameEn: 'Heard Island and Mcdonald Islands', nameCs: 'Heardův ostrov a McDonaldovy ostrovy', code: 'HM' },
  { nameEn: 'Holy See (Vatican City State)', nameCs: 'Vatikán', code: 'VA' },
  { nameEn: 'Honduras', nameCs: 'Honduras', code: 'HN' },
  { nameEn: 'Hong Kong', nameCs: 'Hongkong', code: 'HK' },
  { nameEn: 'Hungary', nameCs: 'Maďarsko', code: 'HU' },
  { nameEn: 'Iceland', nameCs: 'Island', code: 'IS' },
  { nameEn: 'India', nameCs: 'Indie', code: 'IN' },
  { nameEn: 'Indonesia', nameCs: 'Indonésie', code: 'ID' },
  { nameEn: 'Iran, Islamic Republic Of', nameCs: 'Írán', code: 'IR' },
  { nameEn: 'Iraq', nameCs: 'Irák', code: 'IQ' },
  { nameEn: 'Ireland', nameCs: 'Irsko', code: 'IE' },
  { nameEn: 'Isle of Man', nameCs: 'Ostrov Man', code: 'IM' },
  { nameEn: 'Israel', nameCs: 'Izrael', code: 'IL' },
  { nameEn: 'Italy', nameCs: 'Itálie', code: 'IT' },
  { nameEn: 'Jamaica', nameCs: 'Jamajka', code: 'JM' },
  { nameEn: 'Japan', nameCs: 'Japonsko', code: 'JP' },
  { nameEn: 'Jersey', nameCs: 'Jersey', code: 'JE' },
  { nameEn: 'Jordan', nameCs: 'Jordánsko', code: 'JO' },
  { nameEn: 'Kazakhstan', nameCs: 'Kazachstán', code: 'KZ' },
  { nameEn: 'Kenya', nameCs: 'Keňa', code: 'KE' },
  { nameEn: 'Kiribati', nameCs: 'Kiribati', code: 'KI' },
  { nameEn: "Korea, Democratic People'S Republic of", nameCs: 'Severní Korea', code: 'KP' },
  { nameEn: 'Korea, Republic of', nameCs: 'Jižní Korea', code: 'KR' },
  { nameEn: 'Kuwait', nameCs: 'Kuvajt', code: 'KW' },
  { nameEn: 'Kyrgyzstan', nameCs: 'Kyrgyzstán', code: 'KG' },
  { nameEn: "Lao People'S Democratic Republic", nameCs: 'Laos', code: 'LA' },
  { nameEn: 'Latvia', nameCs: 'Lotyšsko', code: 'LV' },
  { nameEn: 'Lebanon', nameCs: 'Libanon', code: 'LB' },
  { nameEn: 'Lesotho', nameCs: 'Lesotho', code: 'LS' },
  { nameEn: 'Liberia', nameCs: 'Libérie', code: 'LR' },
  { nameEn: 'Libyan Arab Jamahiriya', nameCs: 'Libye', code: 'LY' },
  { nameEn: 'Liechtenstein', nameCs: 'Lichtenštejnsko', code: 'LI' },
  { nameEn: 'Lithuania', nameCs: 'Litva', code: 'LT' },
  { nameEn: 'Luxembourg', nameCs: 'Lucembursko', code: 'LU' },
  { nameEn: 'Macao', nameCs: 'Macao', code: 'MO' },
  { nameEn: 'Macedonia, The Former Yugoslav Republic of', nameCs: 'Severní Makedonie', code: 'MK' },
  { nameEn: 'Madagascar', nameCs: 'Madagaskar', code: 'MG' },
  { nameEn: 'Malawi', nameCs: 'Malawi', code: 'MW' },
  { nameEn: 'Malaysia', nameCs: 'Malajsie', code: 'MY' },
  { nameEn: 'Maldives', nameCs: 'Maledivy', code: 'MV' },
  { nameEn: 'Mali', nameCs: 'Mali', code: 'ML' },
  { nameEn: 'Malta', nameCs: 'Malta', code: 'MT' },
  { nameEn: 'Marshall Islands', nameCs: 'Marshallovy ostrovy', code: 'MH' },
  { nameEn: 'Martinique', nameCs: 'Martinik', code: 'MQ' },
  { nameEn: 'Mauritania', nameCs: 'Mauritánie', code: 'MR' },
  { nameEn: 'Mauritius', nameCs: 'Mauricius', code: 'MU' },
  { nameEn: 'Mayotte', nameCs: 'Mayotte', code: 'YT' },
  { nameEn: 'Mexico', nameCs: 'Mexiko', code: 'MX' },
  { nameEn: 'Micronesia, Federated States of', nameCs: 'Mikronésie', code: 'FM' },
  { nameEn: 'Moldova, Republic of', nameCs: 'Moldavsko', code: 'MD' },
  { nameEn: 'Monaco', nameCs: 'Monako', code: 'MC' },
  { nameEn: 'Mongolia', nameCs: 'Mongolsko', code: 'MN' },
  { nameEn: 'Montenegro', nameCs: 'Černá Hora', code: 'ME' },
  { nameEn: 'Montserrat', nameCs: 'Montserrat', code: 'MS' },
  { nameEn: 'Morocco', nameCs: 'Maroko', code: 'MA' },
  { nameEn: 'Mozambique', nameCs: 'Mosambik', code: 'MZ' },
  { nameEn: 'Myanmar', nameCs: 'Myanmar', code: 'MM' },
  { nameEn: 'Namibia', nameCs: 'Namibie', code: 'NA' },
  { nameEn: 'Nauru', nameCs: 'Nauru', code: 'NR' },
  { nameEn: 'Nepal', nameCs: 'Nepál', code: 'NP' },
  { nameEn: 'Netherlands', nameCs: 'Nizozemsko', code: 'NL' },
  { nameEn: 'Netherlands Antilles', nameCs: 'Nizozemské Antily', code: 'AN' },
  { nameEn: 'New Caledonia', nameCs: 'Nová Kaledonie', code: 'NC' },
  { nameEn: 'New Zealand', nameCs: 'Nový Zéland', code: 'NZ' },
  { nameEn: 'Nicaragua', nameCs: 'Nikaragua', code: 'NI' },
  { nameEn: 'Niger', nameCs: 'Niger', code: 'NE' },
  { nameEn: 'Nigeria', nameCs: 'Nigérie', code: 'NG' },
  { nameEn: 'Niue', nameCs: 'Niue', code: 'NU' },
  { nameEn: 'Norfolk Island', nameCs: 'Norfolk', code: 'NF' },
  { nameEn: 'Northern Mariana Islands', nameCs: 'Severní Mariany', code: 'MP' },
  { nameEn: 'Norway', nameCs: 'Norsko', code: 'NO' },
  { nameEn: 'Oman', nameCs: 'Omán', code: 'OM' },
  { nameEn: 'Pakistan', nameCs: 'Pákistán', code: 'PK' },
  { nameEn: 'Palau', nameCs: 'Palau', code: 'PW' },
  { nameEn: 'Palestinian Territory, Occupied', nameCs: 'Palestina', code: 'PS' },
  { nameEn: 'Panama', nameCs: 'Panama', code: 'PA' },
  { nameEn: 'Papua New Guinea', nameCs: 'Papua Nová Guinea', code: 'PG' },
  { nameEn: 'Paraguay', nameCs: 'Paraguay', code: 'PY' },
  { nameEn: 'Peru', nameCs: 'Peru', code: 'PE' },
  { nameEn: 'Philippines', nameCs: 'Filipíny', code: 'PH' },
  { nameEn: 'Pitcairn', nameCs: 'Pitcairnovy ostrovy', code: 'PN' },
  { nameEn: 'Poland', nameCs: 'Polsko', code: 'PL' },
  { nameEn: 'Portugal', nameCs: 'Portugalsko', code: 'PT' },
  { nameEn: 'Puerto Rico', nameCs: 'Portoriko', code: 'PR' },
  { nameEn: 'Qatar', nameCs: 'Katar', code: 'QA' },
  { nameEn: 'Reunion', nameCs: 'Réunion', code: 'RE' },
  { nameEn: 'Romania', nameCs: 'Rumunsko', code: 'RO' },
  { nameEn: 'Russian Federation', nameCs: 'Rusko', code: 'RU' },
  { nameEn: 'RWANDA', nameCs: 'Rwanda', code: 'RW' },
  { nameEn: 'Saint Helena', nameCs: 'Svatá Helena', code: 'SH' },
  { nameEn: 'Saint Kitts and Nevis', nameCs: 'Svatý Kryštof a Nevis', code: 'KN' },
  { nameEn: 'Saint Lucia', nameCs: 'Svatá Lucie', code: 'LC' },
  { nameEn: 'Saint Pierre and Miquelon', nameCs: 'Saint Pierre a Miquelon', code: 'PM' },
  { nameEn: 'Saint Vincent and the Grenadines', nameCs: 'Svatý Vincenc a Grenadiny', code: 'VC' },
  { nameEn: 'Samoa', nameCs: 'Samoa', code: 'WS' },
  { nameEn: 'San Marino', nameCs: 'San Marino', code: 'SM' },
  { nameEn: 'Sao Tome and Principe', nameCs: 'Svatý Tomáš a Princův ostrov', code: 'ST' },
  { nameEn: 'Saudi Arabia', nameCs: 'Saúdská Arábie', code: 'SA' },
  { nameEn: 'Senegal', nameCs: 'Senegal', code: 'SN' },
  { nameEn: 'Serbia', nameCs: 'Srbsko', code: 'RS' },
  { nameEn: 'Seychelles', nameCs: 'Seychely', code: 'SC' },
  { nameEn: 'Sierra Leone', nameCs: 'Sierra Leone', code: 'SL' },
  { nameEn: 'Singapore', nameCs: 'Singapur', code: 'SG' },
  { nameEn: 'Slovenia', nameCs: 'Slovinsko', code: 'SI' },
  { nameEn: 'Solomon Islands', nameCs: 'Šalomounovy ostrovy', code: 'SB' },
  { nameEn: 'Somalia', nameCs: 'Somálsko', code: 'SO' },
  { nameEn: 'South Africa', nameCs: 'Jihoafrická republika', code: 'ZA' },
  {
    nameEn: 'South Georgia and the South Sandwich Islands',
    nameCs: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
    code: 'GS',
  },
  { nameEn: 'Spain', nameCs: 'Španělsko', code: 'ES' },
  { nameEn: 'Sri Lanka', nameCs: 'Srí Lanka', code: 'LK' },
  { nameEn: 'Sudan', nameCs: 'Súdán', code: 'SD' },
  { nameEn: 'Suriname', nameCs: 'Surinam', code: 'SR' },
  { nameEn: 'Svalbard and Jan Mayen', nameCs: 'Špicberky a Jan Mayen', code: 'SJ' },
  { nameEn: 'Swaziland', nameCs: 'Svazijsko (Eswatini)', code: 'SZ' },
  { nameEn: 'Sweden', nameCs: 'Švédsko', code: 'SE' },
  { nameEn: 'Switzerland', nameCs: 'Švýcarsko', code: 'CH' },
  { nameEn: 'Syrian Arab Republic', nameCs: 'Sýrie', code: 'SY' },
  { nameEn: 'Taiwan, Province of China', nameCs: 'Tchaj-wan', code: 'TW' },
  { nameEn: 'Tajikistan', nameCs: 'Tádžikistán', code: 'TJ' },
  { nameEn: 'Tanzania, United Republic of', nameCs: 'Tanzanie', code: 'TZ' },
  { nameEn: 'Thailand', nameCs: 'Thajsko', code: 'TH' },
  { nameEn: 'Timor-Leste', nameCs: 'Východní Timor', code: 'TL' },
  { nameEn: 'Togo', nameCs: 'Togo', code: 'TG' },
  { nameEn: 'Tokelau', nameCs: 'Tokelau', code: 'TK' },
  { nameEn: 'Tonga', nameCs: 'Tonga', code: 'TO' },
  { nameEn: 'Trinidad and Tobago', nameCs: 'Trinidad a Tobago', code: 'TT' },
  { nameEn: 'Tunisia', nameCs: 'Tunisko', code: 'TN' },
  { nameEn: 'Turkey', nameCs: 'Turecko', code: 'TR' },
  { nameEn: 'Turkmenistan', nameCs: 'Turkmenistán', code: 'TM' },
  { nameEn: 'Turks and Caicos Islands', nameCs: 'Turks a Caicos', code: 'TC' },
  { nameEn: 'Tuvalu', nameCs: 'Tuvalu', code: 'TV' },
  { nameEn: 'Uganda', nameCs: 'Uganda', code: 'UG' },
  { nameEn: 'Ukraine', nameCs: 'Ukrajina', code: 'UA' },
  { nameEn: 'United Arab Emirates', nameCs: 'Spojené arabské emiráty', code: 'AE' },
  { nameEn: 'United Kingdom', nameCs: 'Spojené království', code: 'GB' },
  { nameEn: 'United States', nameCs: 'Spojené státy americké', code: 'US' },
  { nameEn: 'United States Minor Outlying Islands', nameCs: 'Menší odlehlé ostrovy USA', code: 'UM' },
  { nameEn: 'Uruguay', nameCs: 'Uruguay', code: 'UY' },
  { nameEn: 'Uzbekistan', nameCs: 'Uzbekistán', code: 'UZ' },
  { nameEn: 'Vanuatu', nameCs: 'Vanuatu', code: 'VU' },
  { nameEn: 'Venezuela', nameCs: 'Venezuela', code: 'VE' },
  { nameEn: 'Viet Nam', nameCs: 'Vietnam', code: 'VN' },
  { nameEn: 'Virgin Islands, British', nameCs: 'Britské Panenské ostrovy', code: 'VG' },
  { nameEn: 'Virgin Islands, U.S.', nameCs: 'Americké Panenské ostrovy', code: 'VI' },
  { nameEn: 'Wallis and Futuna', nameCs: 'Wallis a Futuna', code: 'WF' },
  { nameEn: 'Western Sahara', nameCs: 'Západní Sahara', code: 'EH' },
  { nameEn: 'Yemen', nameCs: 'Jemen', code: 'YE' },
  { nameEn: 'Zambia', nameCs: 'Zambie', code: 'ZM' },
  { nameEn: 'Zimbabwe', nameCs: 'Zimbabwe', code: 'ZW' },
]

export class GeoConfig {
  /** Country list localized by language code ('cs' for Czech, everything else falls back to English). */
  static getCountries(lang: string): GeoListItemType[] {
    return countryList.map(({ nameEn, nameCs, code }) => ({
      name: lang === 'cs' ? nameCs : nameEn,
      code,
    }))
  }

  static get statesUS(): GeoListItemType[] {
    return [
      { name: 'Alabama', code: 'AL' },
      { name: 'Alaska', code: 'AK' },
      { name: 'Arizona', code: 'AZ' },
      { name: 'Arkansas', code: 'AR' },
      { name: 'California', code: 'CA' },
      { name: 'Colorado', code: 'CO' },
      { name: 'Connecticut', code: 'CT' },
      { name: 'Delaware', code: 'DE' },
      { name: 'Florida', code: 'FL' },
      { name: 'Georgia', code: 'GA' },
      { name: 'Hawaii', code: 'HI' },
      { name: 'Idaho', code: 'ID' },
      { name: 'Illinois', code: 'IL' },
      { name: 'Indiana', code: 'IN' },
      { name: 'Iowa', code: 'IA' },
      { name: 'Kansas', code: 'KS' },
      { name: 'Kentucky', code: 'KY' },
      { name: 'Louisiana', code: 'LA' },
      { name: 'Maine', code: 'ME' },
      { name: 'Maryland', code: 'MD' },
      { name: 'Massachusetts', code: 'MA' },
      { name: 'Michigan', code: 'MI' },
      { name: 'Minnesota', code: 'MN' },
      { name: 'Mississippi', code: 'MS' },
      { name: 'Missouri', code: 'MO' },
      { name: 'Montana', code: 'MT' },
      { name: 'Nebraska', code: 'NE' },
      { name: 'Nevada', code: 'NV' },
      { name: 'New Hampshire', code: 'NH' },
      { name: 'New Jersey', code: 'NJ' },
      { name: 'New Mexico', code: 'NM' },
      { name: 'New York', code: 'NY' },
      { name: 'North Carolina', code: 'NC' },
      { name: 'North Dakota', code: 'ND' },
      { name: 'Ohio', code: 'OH' },
      { name: 'Oklahoma', code: 'OK' },
      { name: 'Oregon', code: 'OR' },
      { name: 'Pennsylvania', code: 'PA' },
      { name: 'Rhode Island', code: 'RI' },
      { name: 'South Carolina', code: 'SC' },
      { name: 'South Dakota', code: 'SD' },
      { name: 'Tennessee', code: 'TN' },
      { name: 'Texas', code: 'TX' },
      { name: 'Utah', code: 'UT' },
      { name: 'Vermont', code: 'VT' },
      { name: 'Virginia', code: 'VA' },
      { name: 'Washington', code: 'WA' },
      { name: 'West Virginia', code: 'WV' },
      { name: 'Wisconsin', code: 'WI' },
      { name: 'Wyoming', code: 'WY' },
    ]
  }

  static get statesCA(): GeoListItemType[] {
    return [
      { name: 'Alberta', code: 'AB' },
      { name: 'British Columbia', code: 'BC' },
      { name: 'Manitoba', code: 'MB' },
      { name: 'New Brunswick', code: 'NB' },
      { name: 'Newfoundland and Labrador', code: 'NL' },
      { name: 'Nova Scotia', code: 'NS' },
      { name: 'Northwest Territories', code: 'NT' },
      { name: 'Nunavut', code: 'NU' },
      { name: 'Ontario', code: 'ON' },
      { name: 'Prince Edward Island', code: 'PE' },
      { name: 'Québec', code: 'QC' },
      { name: 'Saskatchewan', code: 'SK' },
      { name: 'Yukon', code: 'YT' },
    ]
  }
}
